import React, { useRef, useState } from 'react'
import { useEffect } from 'react';
import axios from 'axios';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import { Toast } from 'primereact/toast'
import { Api } from '../../../services/api';

import "../../Dasbord.css";

const PreConCreep = () => {
  const toast = useRef(null);
  const [projects, setProjects] = useState([]);
  const [columnName, setColumnName] = useState([]);
  const [RowName, setRowName] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [expandedRows, setExpandedRows] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectOnStartDate, setSelectOnStartDate] = useState('2023-01-01')
  const [selectOnEndDate, setSelectOnEndDate] = useState('2024-12-31')

  useEffect(() => {
    getProject();

  }, []);

  const getProject = () => {
    const token = localStorage.getItem('authToken');

    // Create headers with token if it exists
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };

    fetch(Api.API_BASE_URL + 'get-pre-con-creep', {
      method: "GET",
      headers: headers

    })
      .then((response) => response.json())
      .then((response) => {

        setProjects(response.project)
        setColumnName(response.ColumnName)
        setIsLoading(false);

        var dea = [];
        response.project.forEach(element => {
          const isNameExist = dea.some(item => item.projectType === element.projectType);
          if (isNameExist) {
          } else {
            dea.push(element);
          }
        })

        setExpandedRows(dea);
        //  setRowName(response.data.RowName);

        var arr2 = [];
        response.ColumnName.forEach(element => {

          var ar = [{
            field: element,
            name: response.RowName[0],

          },
          {
            field: element,
            name: response.RowName[1],

          }]

          var mergedArray = arr2.concat(ar);
          arr2 = mergedArray;

        });

        setRowName(arr2);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error:", error);
      });

    //   const token = localStorage.getItem('authToken');

    // // Create headers with token if it exists
    // const headers = {
    //   'Content-Type': 'application/json',
    //   'Authorization': token ? `Bearer ${token}` : ''
    // };

    axios.get(Api.API_BASE_URL + 'get-startDate-endDate', { headers: headers })

      .then((response) => {
        console.log('response', response.data.result)

        setSelectOnStartDate(response.data.result.startDate)
        setSelectOnEndDate(response.data.result.endDate)
      })
      .catch((error) => {
        console.error('Error fetching projects:', error);
      });

  }

  const lastYearSaleBodyTemplate = (col, rowname, rowData) => {
    return priceBodyTemplate(rowData[col.field][col.name]);
  };

  const showMonthIs = (myString) => {
    var myArray = myString.split(' ');

    var arr = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",];
    var index = arr.indexOf(myArray[0]) + 1;
    var year = myArray[1];
    if (myArray[0] === 'Year') {
      return true;
      // index = 12;
    }

    var year = myArray[1];
    if (myArray[0] === 'QUARTER') {
      year = myArray[2]
      if (myArray[1] == '1') {
        index = 3;
      }
      if (myArray[1] == '2') {
        index = 6;
      }
      if (myArray[1] == '3') {
        index = 9;
      }
      if (myArray[1] == '4') {
        // return true;
        index = 12;
      }

    }

    let startDate = selectOnStartDate;
    let endDate = selectOnEndDate;

    if(!startDate || !endDate) return true;

    const date1 = new Date(startDate);
    const date2 = new Date(endDate);
    
    if (isNaN(date1.getTime()) || isNaN(date2.getTime())) return true;

    const month = new Date(year + '-' + index + '-01');
    // Extract year and month from date1 and date2
    const year1 = date1.getFullYear();
    const month1 = date1.getMonth();

    const year2 = date2.getFullYear();
    const month2 = date2.getMonth();

    // Extract year and month from the target month
    const targetYear = month.getFullYear();
    const targetMonth = month.getMonth();

    // Check if the target month falls within the date range
    if (
      (targetYear > year1 || (targetYear === year1 && targetMonth >= month1)) &&
      (targetYear < year2 || (targetYear === year2 && targetMonth <= month2))
    ) {

      return true;
    } else {

      return false;
    }

    return false;
  }

  const headerGroup = (
    <ColumnGroup>
      <Row>
        <Column header="Project" frozen rowSpan={2} style={{ minWidth: '300px', textAlign: "center", borderRight: '3px solid gray', fontSize: '0.85rem', padding: '0.5rem' }} />

        {columnName.map((row, i) => showMonthIs(row) ? (
          <Column key={i} header={row} colSpan={2} style={{ minWidth: '140px', textAlign: "center", borderRight: '2px solid black', fontSize: '0.85rem', padding: '0.5rem', backgroundColor: /QUARTER \d{1,2} \d{4}|Year \d{4}/.test(row) ? "#FFC000" : "", }} />

        ) : null)}
      </Row>

      <Row>
        {RowName.map((row, i) => showMonthIs(row.field) ? (
          <Column
            key={i}
            header={row.name}
            style={{
              minWidth: '70px',
              textAlign: "center",
              padding: "0.25rem",
              borderRight: row.name === 'DIRECT COSTS PM' ? '3px solid black' : 'none',
              fontSize: '0.85rem',
              whiteSpace: 'nowrap'
            }}
          />
        ) : null)}
      </Row>
    </ColumnGroup>
  );

  const headerTemplate = (data) => {
    var t = data.projectType;

    return (
      <React.Fragment>
        <td colSpan="1" className="no-horizontal-scroll  p-frozen-column myheader">
          <span style={{ overflowX: "hidden", whiteSpace: "nowrap" }}>
            <i className="pi pi-circle-fill" style={{ color: "#" + data.projectTypeColorCode }}></i>{t}
          </span>
        </td>
      </React.Fragment>
    );
  };



  const priceBodyTemplate = (value) => {
    const isNegative = value < 0;
    const hasValue = value !== '' && value != null && value != 0;
    const backgroundColor = hasValue ? '#fcd9d9' : 'transparent'; // Apply red background if value exists
    const color = backgroundColor === '#fcd9d9' ? 'red' : 'black'; // Set text color to white if background is red
    const border = backgroundColor === '#fcd9d9' ? '1px solid red' : ''; // Set text color to white if background is red
    // const border = 

    return (
      <div style={{
        color: color,
        // backgroundColor: backgroundColor, 
        // border: border, 
        padding: "1px",
        width: '100%',
        fontSize: '0.85rem',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }}>

        {value === '' || value == null ? '' : formatCurrency(value)}
      </div>
    );
  };

  const formatCurrency = (value) => {
    return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  };


  const rowClass = (data) => {
    return {
      'bg-gray-300': data.projectType === 'TOTAL' || data.projectType === 'ZC FSA PROJECTIONS' || data.projectType === 'ZB FORECAST VS ACTULS' || data.projectType === 'ZD AJS PROJECTIONS' || data.projectType === 'ZE DIVISION PROJECTIONS'
    };
  };

  return (
    <div className="dashboard-container flex flex-column overflow-hidden" style={{ height: 'calc(100vh - 70px)', minHeight: '0', padding: '0' }}>
      <div className="flex-grow-1 overflow-hidden p-0" style={{ backgroundColor: '#fff' }}>
        <div className="card h-full flex flex-column shadow-none border-none bg-white p-0 pb-2">
          <Toast ref={toast} />

          {isLoading ? (
            <div className="flex align-items-center justify-content-center h-full">
              <div className="loading-spinner">
                Loading...
                <div className="spinner"></div>
              </div>
            </div>
          ) : (
             <DataTable
                value={projects}
                rowClassName={rowClass}
                rowGroupMode="subheader"
                groupRowsBy="projectType"
                showGridlines
                expandableRowGroups={true}
                rowGroupHeaderTemplate={headerTemplate}
                sortMode="single"
                sortField="projectType"
                sortOrder={0}
                scrollable
                scrollHeight="flex"
                size="small"
                className="p-datatable-sm text-sm"
                selectionMode="single" 
                selection={selectedProduct} 
                onSelectionChange={(e) => setSelectedProduct(e.value)}
                expandedRows={expandedRows}
                onRowToggle={(e) => setExpandedRows(e.data)}
                headerColumnGroup={headerGroup}
                tableStyle={{ minWidth: "50rem", cursor: "pointer", borderCollapse: 'separate', borderSpacing: '0' }}
              >
                <Column field="projectName" style={{ minWidth: "220px", maxWidth: '300px', borderRight: '3px solid gray', fontSize: '0.85rem', padding: '0.5rem' }} frozen bodyClassName="cashPad font-bold" />

                {RowName.map((col, i) => showMonthIs(col.field) ? (
                  <Column
                    key={i}
                    field={col.name}
                    body={(e) => lastYearSaleBodyTemplate(col, "Fee PM", e)}
                    style={{
                      textAlign: "center",
                      borderRight: col.name === 'DIRECT COSTS PM' ? '3px solid black' : 'none',
                      padding: "0.25rem",
                      minWidth: '70px',
                      fontSize: '0.85rem',
                      backgroundColor: /QUARTER \d{1,2} \d{4}|Year \d{4}/.test(col.field) ? "#FFC000" : "",
                    }}
                  />
                ) : null)}
              </DataTable>
          )}
        </div>
      </div>
    </div>
  );
}

export default PreConCreep
